export type StepMode = "linear" | "ease_in" | "ease_out" | "ease_inout"; // extend as needed

export class EffectStep {
  id: string;
  name: string;
  time: number;
  value: any;
  mode: StepMode;

  constructor(data: Partial<EffectStep> = {}) {
    this.id = data.id ?? crypto.randomUUID();
    this.name = data.name ?? "";
    this.time = data.time ?? 0;
    this.value = data.value ?? 0;
    this.mode = data.mode ?? "linear";
  }
}
